import axios from 'axios';

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const endpoints = {
  auth: {
    login: '/auth/login',
    verify: '/auth/verify',
  },
  questionAnswer: {
    datasources: '/question-answer/datasources',
    update: (datasourceId: string, id: string) =>
      `/question-answer/${datasourceId}/pairs/${id}`,
    internalComment: (datasourceId: string, id: string) =>
      `/question-answer/${datasourceId}/pairs/${id}/internal-comment`,
    feedback: (datasourceId: string, id: string) =>
      `/question-answer/${datasourceId}/pairs/${id}/feedback`,
  },
  assertions: {
    datasources: '/assertions/datasources',
    update: (datasourceId: string, id: string) =>
      `/assertions/${datasourceId}/records/${id}`,
    modules: (datasourceId: string) => `/assertions/${datasourceId}/modules`,
  },
  validationProcess: {
    start: '/validation-process',
    pending: '/validation-process/pending',
    finalized: '/validation-process/finalized',
    cancel: (processId: string) => `/validation-process/${processId}/cancel`,
    finalize: (processId: string) =>
      `/validation-process/${processId}/finalize`,
    completedTasks: (processId: string) =>
      `/validation-process/${processId}/completed-tasks`,
    skills: (processId: string) => `/validation-process/${processId}/skills`,
    severityCounts: (processId: string) =>
      `/validation-process/${processId}/severity-counts`,
    replayCompletedTask: (processId: string, questionAnswerPairId: string) =>
      `/validation-process/${processId}/completed-tasks/${questionAnswerPairId}/replay`,
    secondOpinion: (processId: string, questionAnswerPairId: string) =>
      `/validation-process/${processId}/completed-tasks/${questionAnswerPairId}/second-opinion`,
    customerApprovalRequest: (
      processId: string,
      questionAnswerPairId: string,
    ) =>
      `/validation-process/${processId}/completed-tasks/${questionAnswerPairId}/customer-approval-request`,
    approveCompletedTask: (processId: string, questionAnswerPairId: string) =>
      `/validation-process/${processId}/completed-tasks/${questionAnswerPairId}/approve`,
    selectionOverride: (processId: string, questionAnswerPairId: string) =>
      `/validation-process/${processId}/completed-tasks/${questionAnswerPairId}/selection-override`,
    rejectCompletedTask: (processId: string, questionAnswerPairId: string) =>
      `/validation-process/${processId}/completed-tasks/${questionAnswerPairId}/reject`,
    history: '/validation-process/history',
    report: (processId: string) => `/validation-process/${processId}/report`,
  },
  assertionValidationProcess: {
    start: '/assertion-validation-process',
    pending: '/assertion-validation-process/pending',
    cancel: (processId: string) =>
      `/assertion-validation-process/${processId}/cancel`,
    retryFailures: (processId: string) =>
      `/assertion-validation-process/${processId}/retry-failures`,
    completedTasks: (processId: string) =>
      `/assertion-validation-process/${processId}/completed-tasks`,
    replayCompletedTask: (processId: string, assertionId: string) =>
      `/assertion-validation-process/${processId}/completed-tasks/${assertionId}/replay`,
    customerApprovalRequest: (processId: string, assertionId: string) =>
      `/assertion-validation-process/${processId}/completed-tasks/${assertionId}/customer-approval-request`,
    approveCompletedTask: (processId: string, assertionId: string) =>
      `/assertion-validation-process/${processId}/completed-tasks/${assertionId}/approve`,
    rejectCompletedTask: (processId: string, assertionId: string) =>
      `/assertion-validation-process/${processId}/completed-tasks/${assertionId}/reject`,
    history: '/assertion-validation-process/history',
    report: (processId: string) =>
      `/assertion-validation-process/${processId}/report`,
    finalize: (processId: string) =>
      `/assertion-validation-process/${processId}/finalize`,
  },
} as const;
